import AppContext from "PFApp/app_context";
import { CustomValuesEditField } from "PFApp/components/custom_values_edit_field";
import { Typography } from "PFComponents/typography";
import React, { useContext, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PreferencesFormValues } from "../edit_preferences_modal";
import css from "../edit_preferences_modal.module.scss";

export const PreferredSkills = (): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "editPreferencesModal" });
  const {
    store: { customTypes }
  } = useContext(AppContext);
  const skillsCustomType = useMemo(() => customTypes.find((type) => type.name === "skills"), [customTypes]);

  const { control } = useFormContext<PreferencesFormValues>();

  return (
    <div className={css.row}>
      <Typography variant="labelRegular" className={css.label}>
        {t("skills")}
      </Typography>
      <Controller
        name="skills"
        control={control}
        render={({ field }) => (
          <CustomValuesEditField
            qaIdPrefix="edit-preferences-modal-skills"
            kind="bordered"
            tip=""
            label=""
            customType={skillsCustomType!}
            values={field.value}
            handleChange={field.onChange}
            letCreate={false}
            forceUnlocked
          />
        )}
      />
    </div>
  );
};
